import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ShieldCheck, Check, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { useAuth } from '../context/AuthContext';

/**
 * v4.1 Final Pre-Outreach Cleanup (A2) — Subscription surface.
 *
 * Previous version rendered a SaaS upgrade card with a monthly price.
 * HussarAi is not a SaaS product. This screen now shows the neutral
 * access status for the signed-in user and points institutional /
 * professional traffic to the pilot programme.
 *
 * No SaaS-tier copy. No pricing. No Border Guard donation. No upgrade CTA.
 * Doctrine: AI przygotowuje. Człowiek decyduje.
 */
const Subscription = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="hussar-app">
      <header className="hussar-app-header">
        <div className="hussar-app-header-content">
          <Button variant="ghost" className="hussar-btn-back" onClick={() => navigate('/app')} data-testid="subscription-back">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="hussar-logo-full">
            <img src="/hussarai-logo-full.png" alt="HussarAi" className="hussar-logo-full-img-small" />
          </div>
          <div></div>
        </div>
      </header>

      <div className="hussar-subscription-page" data-testid="subscription-page">
        <div className="hussar-subscription-container">
          <h1 className="hussar-subscription-title" data-testid="subscription-title">{t('subscription.title')}</h1>

          <Card className="hussar-subscription-card" data-testid="subscription-access-card">
            <div className="hussar-subscription-doctrine" style={{ marginBottom: 24 }}>
              <ShieldCheck className="w-6 h-6" style={{ color: '#00D4FF', marginBottom: 8 }} />
              <p style={{ margin: 0, opacity: 0.85 }}>
                HussarAi — spójność akt imigracyjnych. AI przygotowuje. Człowiek decyduje.
              </p>
            </div>

            <h2 className="hussar-subscription-plan" data-testid="subscription-plan-name">
              {t('subscription.planFree')}
            </h2>

            <p className="hussar-subscription-info" data-testid="subscription-email">
              Email: {user?.email}
            </p>

            <div className="hussar-subscription-features" style={{ marginTop: 24 }}>
              <div className="hussar-subscription-feature">
                <Check className="w-5 h-5" style={{ color: '#00D4FF' }} />
                <span>{t('subscription.feature1')}</span>
              </div>
              <div className="hussar-subscription-feature">
                <Check className="w-5 h-5" style={{ color: '#00D4FF' }} />
                <span>{t('subscription.feature2')}</span>
              </div>
              <div className="hussar-subscription-feature">
                <Check className="w-5 h-5" style={{ color: '#00D4FF' }} />
                <span>{t('subscription.feature3')}</span>
              </div>
              <div className="hussar-subscription-feature">
                <Check className="w-5 h-5" style={{ color: '#00D4FF' }} />
                <span>{t('subscription.feature4')}</span>
              </div>
            </div>

            <div className="hussar-subscription-upgrade-section" style={{ marginTop: 32 }}>
              <h3 className="hussar-upgrade-title" data-testid="subscription-pilot-title">
                {t('subscription.upgradeTitle')}
              </h3>
              <p className="hussar-upgrade-description">
                {t('subscription.upgradeDescription')}
              </p>

              <Button
                onClick={() => navigate('/pilot-publiczny')}
                className="hussar-btn-primary hussar-btn-full hussar-btn-large"
                data-testid="subscription-pilot-cta"
              >
                <Mail className="w-5 h-5" />
                {t('subscription.goPremium')}
              </Button>

              <p className="hussar-upgrade-cancel" style={{ marginTop: 12 }}>
                {t('subscription.cancelAnyTime')}
              </p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
